import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper, getSemanticTextColor } from '../../../utils';

export const MenuCloseIcon = ({
  color = 'white',
  width = 20,
  marginLeft,
  marginRight,
  containerSize,
  title,
}: DefaultIconProps) => (
  <DefaultIconWrapper
    marginRight={marginRight}
    marginLeft={marginLeft}
    containerSize={containerSize}
    title={title}
    width={width}
  >
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <g fill={getSemanticTextColor(color)}>
        <path
          fillRule="evenodd"
          d="M19.192.808c.363.362.389.934.078 1.327l-.078.087L11.414 10l7.778 7.778c.39.39.39 1.024 0 1.414-.362.363-.934.389-1.327.078l-.087-.078L10 11.414l-7.778 7.778c-.39.39-1.024.39-1.414 0-.363-.362-.389-.934-.078-1.327l.078-.087L8.585 10 .808 2.222c-.39-.39-.39-1.024 0-1.414C1.17.445 1.742.419 2.135.73l.087.078L10 8.585 17.778.808c.39-.39 1.024-.39 1.414 0z"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
